"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameCenterModuleLockType = void 0;
var GameCenterModuleLockType;
(function (GameCenterModuleLockType) {
    GameCenterModuleLockType["START_DATE_COUNT_DOWN"] = "START_DATE_COUNT_DOWN";
    GameCenterModuleLockType["GAME_LOCK"] = "GAME_LOCK";
    GameCenterModuleLockType["REWARD_LOCK"] = "REWARD_LOCK";
    GameCenterModuleLockType["REWARD_COOL_DOWN"] = "REWARD_COOL_DOWN";
    GameCenterModuleLockType["REWARD_OUT_OF_STOCK"] = "REWARD_OUT_OF_STOCK";
    GameCenterModuleLockType["ADVENTURE_GAMIFICATION"] = "ADVENTURE_GAMIFICATION";
    GameCenterModuleLockType["REWARD_GAMIFICATION"] = "REWARD_GAMIFICATION";
    GameCenterModuleLockType["ATTEMPT_GAMIFICATION"] = "ATTEMPT_GAMIFICATION";
})(GameCenterModuleLockType || (exports.GameCenterModuleLockType = GameCenterModuleLockType = {}));
